export class RequestExperiments {
    #f: string[] = [];
    #p = 'schema_id:';

    constructor(...flags: string[]) {
        this.#f = flags;
    }

    WithFlag(flag: string, optionalCondition?: boolean): this {
        if (optionalCondition !== undefined && !optionalCondition) {
            return this;
        }

        this.#f.push(flag);
        return this;
    }

    WithSchema(id: string): this {
        const i = this.#f.findIndex((v) => v.startsWith(this.#p));
        i === -1 ? this.#f.push(this.#p + id) : (this.#f[i] = this.#p + id);
        return this;
    }

    Get(): string[] {
        return this.#f;
    }

    Has(name: string): boolean {
        return this.#f.includes(name);
    }

    Marshal(): string {
        return JSON.stringify(this.#f);
    }
}

export function getRequestExperiments(
    isIntelligentBriefsEnabled: boolean,
    isWeddingBrief: boolean,
    isIntelligentStylesEnabled: boolean,
    schemaId?: string,
    referenceProjectsEnabled?: boolean
) {
    const experiments = new RequestExperiments();

    if (schemaId) {
        experiments.WithSchema(schemaId);
    }

    if (isWeddingBrief) {
        experiments.WithSchema('careDesignWeddingInvitation@Latest');
    }

    if (isIntelligentBriefsEnabled) {
        experiments.WithFlag('intelligent_briefs').WithSchema('careDesignProjectOverviewV4');
    }

    if (referenceProjectsEnabled) {
        experiments.WithFlag('reference_projects');
    }

    if (isIntelligentStylesEnabled) {
        experiments.WithSchema('careDesignIntelligentStyles@Latest');
    }

    return experiments.Get();
}
